"use client";
import { gsap } from "gsap";
import { useEffect, useRef } from "react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Calendar, Globe, Users, Handshake, Mic, Briefcase } from "lucide-react";

gsap.registerPlugin(ScrollTrigger);

const StatsBar = () => {
  const root = useRef(null);

  const statsData = [
    { icon: <Calendar />, number: "10+", label: "Years of Experience" },
    { icon: <Users />, number: "50+", label: "Expert Team Members" },
    { icon: <Globe />, number: "10+", label: "Countries Served" },
    { icon: <Handshake />, number: "100+", label: "Happy Clients" },
    { icon: <Briefcase />, number: "300+", label: "Projects Delivered" },
    { icon: <Mic />, number: "25+", label: "Industry Talks" },
  ];

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        ".stat-card",
        { opacity: 0, y: 20 },
        {
          scrollTrigger: { trigger: root.current, start: "top 90%" },
          y: 0,
          opacity: 1,
          duration: 0.5,
          stagger: 0.1,
          ease: "power2.out",
        },
      );
    }, root);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={root} className="w-full bg-background-primary !py-6 min-[2560px]:!py-16 relative z-10">
      <div className="!mx-auto !px-6 md:px-12 max-w-[4000px]">
        <div className="!mb-6 min-[2560px]:!mb-12">
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-600 to-purple-600 dark:from-cyan-400 dark:to-purple-600 text-[18px] min-[2560px]:text-[28px] font-medium font-semibold !mb-1">
            By the numbers
          </span>
          <h3 className="text-[24px] md:text-[32px] min-[2560px]:text-[56px] font-normal text-text-primary tracking-tight">
            Crafting digital excellence that powers businesses forward.
          </h3>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 !gap-2 min-[2560px]:!gap-5">
          {statsData.map((stat, i) => (
            <div
              key={i}
              className="stat-card flex flex-col !p-5 min-[2560px]:!p-10 rounded-2xl border border-border-primary hover:border-purple-500/50 transition-all group"
              style={{
                background: "var(--card-background)",
                boxShadow: "var(--card-shadow)",
              }}
            >
              <div className="flex items-center !gap-3 min-[2560px]:!gap-6 !mb-2 min-[2560px]:!mb-4">
                <div className="text-[#8b5cf6] *:w-6 *:h-6 min-[2560px]:*:w-12 min-[2560px]:*:h-12">{stat.icon}</div>
                <div className="text-[22px] min-[2560px]:text-[44px] font-bold text-text-primary leading-none">{stat.number}</div>
              </div>

              <div className="text-[13px] min-[2560px]:text-[24px] text-text-secondary whitespace-pre-line leading-snug">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsBar;
